module.exports = __webpack_public_path__ + "static/media/vs.236140e5.webp";